export default __webpack_public_path__ + "images/IL.b2d227b.png";